import { Loader } from './Loader'

interface IconButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  isSubmitting?: boolean
  iconSrc: string
}

export const IconButton = ({
  children,
  iconSrc,
  isSubmitting = false,
  ...buttonProps
}: IconButtonProps): JSX.Element => (
  <button
    className='relative mt-2 w-full py-4 px-16 bg-[#FDFCFF] font-medium rounded-lg border-[3px] border-black shadow-lg md:drop-shadow-md hover-hover:hover:bg-black hover-hover:hover:bg-opacity-5 active:bg-black active:bg-opacity-5'
    disabled={isSubmitting}
    {...buttonProps}
  >
    {isSubmitting && <Loader color='black' />}
    {!isSubmitting && (
      <img className='inline-block absolute left-6' width={25} src={iconSrc} />
    )}
    <p>{children}</p>
  </button>
)
